import React, { createContext, useContext, useState, useCallback } from 'react';

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
    const [confirmState, setConfirmState] = useState({
        isOpen: false,
        message: '',
        resolve: null
    });

    const showConfirm = useCallback((message) => {
        return new Promise((resolve) => {
            setConfirmState({ isOpen: true, message, resolve });
        });
    }, []);

    const handleConfirm = useCallback(() => {
        confirmState.resolve(false);
        setConfirmState((s) => ({ ...s, isOpen: false }));
    }, [confirmState]);

    return (
      <ConfirmContext.Provider value={showConfirm}>
          {children}

          {confirmState.isOpen && (
            <ConfirmModal
              message={confirmState.message}
              onConfirm={handleConfirm}
            />
          )}
      </ConfirmContext.Provider>
    );
}

export function useCustomConfirm() {
    const context = useContext(ConfirmContext);
    if (!context) {
        throw new Error('useCustomConfirm must be used within ConfirmProvider');
    }
    return context;
}

function ConfirmModal({ message, onConfirm }) {
    return (
          <div className="inset-0 flex items-center justify-center bg-black/10 fixed">
          <div className="bg-white p-6 rounded-lg shadow-xl">
              <p className="mb-4">{message}</p>
              <div className="flex justify-end space-x-2">
                  <button className="px-4 py-2 bg-blue-500 text-white rounded" onClick={onConfirm}>
                      ОК
                  </button>
              </div>
          </div>
      </div>
    );
}

